import { FormEvent } from 'react'
import { Head, Link, useForm } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import PageTitle from '@/components/PageTitle'
import { Button } from '@/components/ui/Button'
import CardForm, { type CardFormData, type CardOptions } from '@/components/cards/CardForm'

const EMPTY: CardFormData = {
  cr_name: '',
  name: '',
  description: '',
  count: 1,
  arena: 0,
  rarity: 'common',
  card_type: 'troop',
  transport: '',
  target_air: false,
  target_ground: true,
  focus: 'units',
  range_tiles: '',
  speed: '',
  hit_speed: '',
  first_hit_speed: '',
  cost: 0,
  form_size: '',
  concept_image: null,
  design_image: null,
  cr_image: null,
}

export default function CardsNew({ options }: { options: CardOptions }) {
  const form = useForm<CardFormData>(EMPTY)

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.transform((data) => ({ card: data }))
    form.post('/cards')
  }

  return (
    <AppLayout header={<PageTitle title="New Card" />}>
      <Head title="New Card" />
      <form onSubmit={submit} className="max-w-5xl space-y-6">
        <CardForm data={form.data} errors={form.errors} setData={form.setData} options={options} />
        <div className="flex gap-2">
          <Button type="submit" disabled={form.processing}>
            {form.processing ? 'Creating…' : 'Create card'}
          </Button>
          <Button asChild variant="outline" type="button">
            <Link href="/cards">Cancel</Link>
          </Button>
        </div>
      </form>
    </AppLayout>
  )
}
